import React, { Component } from 'react';
import { Input, List, Typography } from 'antd';
import { Icon, Tree, message } from 'antd';
import { Pagination } from 'antd';
import PropTypes from 'prop-types';
import { apis } from '../api/index.js';
import 'moment/locale/zh-cn';
import { eventListener } from '../utils';
const { Search } = Input;
const { TreeNode, DirectoryTree } = Tree;

const [productionId, pageId] = ['101', '10023'];
class KnowledgeTree extends Component {
  static propTypes = {
    form: PropTypes.object,
    history: PropTypes.object,
    privateFlag: PropTypes.bool,
    searchValueClear: PropTypes.bool,
    setUpperDataList: PropTypes.func,
    setFileFlag: PropTypes.func,
    updateTreeData: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      privateFlag: false,

      treeData: [],
      detail: {},
      currentSelected: {},
      searchText: '',
      loadedKeys: [],
      kPageSize: 30,
    };
  }

  componentDidUpdate(prevProps) {
    const { privateFlag, updateTreeData } = this.props;
    if (
      privateFlag !== prevProps.privateFlag ||
      updateTreeData !== prevProps.updateTreeData
    )
      this.getTreeDate();

    if (this.props.searchValueClear !== prevProps.searchValueClear)
      this.handleTabClick();
  }

  componentDidMount() {
    this.getTreeDate();
  }

  handleTabClick = () => {
    const searchPublic = this.searchPublic;
    searchPublic.input.state.value = '';
  };
  getTreeDate = () => {
    const { privateFlag } = this.props;
    apis.knowledgeTree(privateFlag).then(res => {
      if (res.code === '0') {
        this.setState({ treeData: res.data, loadedKeys: [] });
        this.props.setUpperDataList(res.data);
      } else if (res.code === '1009') {
        message.error('请先登录');
        this.props.history.push('/login');
      }
    });
  };

  pageOnChange = page => {
    const size = this.state.kPageSize;
    const value = this.state.searchText;
    apis.knowledgeList(false, value, page, size).then(res => {
      if (res.code === '0') {
        this.setState({
          searchText: value,
          treeList: res.data.list || [],
          total: res.data.total,
        });
      } else if (res.code === '1009') {
        message.error('请先登录');
        this.props.history.push('/login');
      }
    });
  };
  knowledgeDetail1 = detail => {
    const id = detail.id;
    this.knowledgeDetail(undefined, undefined, id);
  };
  knowledgeDetail = (selectedKeys, e, id) => {
    if (selectedKeys && e) {
      this.setState({ clickedNode: e.node });
      id = selectedKeys[0];
    }

    apis.knowledgeDelectById(id).then(res => {
      if (res.code === '0') {
        this.setState({ detail: res.data });

        this.props.form.setFieldsValue({
          name: res.data.name,
          upper: res.data.upper,
          sort: res.data.orderNum,
          pinyin: res.data.namepy,
          wubi: res.data.namewb,
          finding: res.data.finding,
          impression: res.data.impression,
        });

        this.props.setFileFlag(res.data, e.node.props.dataRef);
      } else if (res.code === '1009') {
        message.error('请先登录');
        this.props.history.push('/login');
      }
    });
  };

  filterTreeData = async (value, flag) => {
    const size = this.state.kPageSize;

    await apis.knowledgeList(flag, value, 1, size).then(res => {
      if (res.code === '0') {
        this.setState({
          searchText: value,
          treeList: res.data.list || [],
          total: res.data.total,
        });
      } else if (res.code === '1009') {
        message.error('请先登录');
        this.props.history.push('/login');
      }
    });
  };

  onLoadData = (treeNode, type) =>
    new Promise(resolve => {
      if (treeNode && treeNode.props && treeNode.props.child) {
        resolve();
        return;
      }
      const { loadedKeys } = this.state;
      const { privateFlag } = this.props;
      let id = undefined;
      if (treeNode && treeNode.props && treeNode.props.dataRef)
        id = treeNode.props.dataRef.id;

      loadedKeys.push(id + '');
      apis.knowledgeTree(privateFlag, id).then(res => {
        if (res.code === '0') {
          if (treeNode && treeNode.props && treeNode.props.dataRef)
            treeNode.props.dataRef.child = res.data;

          const treeData = [...this.state.treeData];
          this.setState({ treeData });
          this.props.setUpperDataList(treeData);
          resolve();
        } else if (res.code === '1009') {
          message.error('请先登录');
          this.props.history.push('/login');
        }
      });
    });

  onExpand = (expandedKeys, { expanded: bool, node }) => {
    const item = node.props.dataRef;
    const { name } = item;
    let elementId;
    switch (name) {
      case '九峰模板':
        elementId = 'ns-001';
        break;
      case '常用模板':
        elementId = 'ns-002';
        break;
      case '简化模板':
        elementId = 'ns-003';
        break;
      case '新疆模板':
        elementId = 'ns-004';
        break;
      case '传统模板':
        elementId = 'ns-005';
        break;
      case '造影':
        elementId = 'ns-006';
        break;
      case '南京X线模板':
        elementId = 'ns-007';
        break;
      default:
        break;
    }
    elementId &&
      eventListener({ productionId, pageId, moduleId: 'mk0001', elementId });
  };

  renderTreeNodes = data =>
    data.map(item => {
      const icon = item.fileFlag ? (
        <Icon type="folder" theme="filled" />
      ) : (
        <Icon className="file" type="file" theme="filled" />
      );
      if (item.child)
        return (
          <TreeNode icon={icon} title={item.name} key={item.id} dataRef={item}>
            {this.renderTreeNodes(item.child)}
          </TreeNode>
        );

      return (
        <TreeNode
          icon={icon}
          key={item.id}
          {...item}
          dataRef={item}
          isLeaf={false}
          showIcon={true}
        />
      );
    });
  render() {
    const { searchText } = this.state;
    const { privateFlag } = this.props;

    const leftHeight = window.screen.height - 320;
    const treeHeight = leftHeight - (privateFlag ? 112 : 200);
    return (
      <div>
        <div className="knowledge-search">
          <Search
            ref={c => (this.searchPublic = c)}
            placeholder="输入关键字按下Enter键搜索"
            onSearch={value => this.filterTreeData(value, privateFlag)}
          />
        </div>

        <div
          className="knowledge-left-tree-content"
          style={{ height: treeHeight }}
        >
          {searchText !== '' && searchText.trim() !== '' ? (
            <div className="knowledge-search-page">
              {/* 搜索结果 */}
              <List
                dataSource={this.state.treeList}
                renderItem={item => {
                  const { searchText } = this.state;
                  const len = searchText.length;
                  const index = item.name.indexOf(searchText);
                  let { name, fileFlag } = item;

                  if (index >= 0) {
                    const left = name.substring(0, index);
                    const center = name.substring(index, index + len);
                    const right = name.substring(index + len);
                    name = (
                      <>
                        {left}
                        <Typography.Text mark>{center}</Typography.Text>
                        {right}
                      </>
                    );
                  }
                  return (
                    <div className={fileFlag ? 'title' : 'list'}>
                      {!fileFlag && <Icon type="file-text" theme="filled" />}
                      <List.Item
                        className={fileFlag ? '' : 'cursor'}
                        onClick={() => this.knowledgeDetail1(item)}
                      >
                        {name}
                      </List.Item>
                    </div>
                  );
                }}
              />
              <Pagination
                size="small"
                total={this.state.total}
                pageSize={this.state.kPageSize}
                onChange={this.pageOnChange}
              ></Pagination>
            </div>
          ) : (
            <DirectoryTree
              loadData={this.onLoadData}
              onSelect={this.knowledgeDetail}
              loadedKeys={this.state.loadedKeys}
              switcherIcon={<Icon type="caret-down" />}
              onExpand={this.onExpand}
            >
              {this.renderTreeNodes(this.state.treeData)}
            </DirectoryTree>
          )}
        </div>
      </div>
    );
  }
}

export default KnowledgeTree;
